<template lang="pug">
v-dialog(v-model="dialog" width="600" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-3(small color="green" dark outlined rounded v-on="on")
            v-icon mdi-plus
            | Add to Template
    v-card(:loading="loading")
        v-card-title Add to Template
        v-card-text
            //- v-card-text Select template {{ defaultAnswer }} {{ id }}
            feathers-vuex-find(service="bh-toluna-templates" :query="{}" :fetch-query="{ $limit: -1 }" watch="query")
                template(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
                    v-combobox(v-model="form.name" label="Template Name" :items="parseItems(desserts)" :disable="loading")

        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!loading" small color="red" text @click="dialog = false") Cancel
            v-btn(small color="primary" text @click="addToTemplate" :loading="loading") Confirm

    //- v-snackbar(v-model="error.show" top color="red")
    //-     v-icon(left) mdi-alert-circle-outline
    //-     | {{ error.message }}
    //-     template(v-slot:action="{ attrs }")
    //-         v-btn(
    //-             color="white"
    //-             text
    //-             v-bind="attrs"
    //-             @click="error.show = false"
    //-         ) Close
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        id: Number,
        defaultAnswer: Number
    },
    data() {
        return {
            error: {
                show: false,
                message: null
            },
            loading: false,
            dialog: false,
            form: {
                name: null
            }
        };
    },
    methods: {
        parseItems(desserts) {
            return desserts.filter((item) => {
                const json = JSON.parse(item.data);
                const existing = json.filter(i => i.id === this.id);
                return existing.length === 0;
            }).map(item => item.name);
        },
        async addToTemplate() {
            if(!!this.form.name) {
                this.loading = true;
                const items = await this.findItem({
                    query: { name: this.form.name }
                });
                if(!!items.data[0]) {
                    const data = JSON.parse(items.data[0].data);
                    if(data.filter(i => i.id === this.item).length === 0) {
                        try {
                            data.push({ id: this.id, value: this.defaultAnswer });
                            items.data[0].data = JSON.stringify(data.map(($i, $index) => {
                                $i.sort = $index;
                                return $i;
                            }));
                            await items.data[0].patch();
                            this.dialog = false;
                            this.form.name = null;
                            this.$emit('success');
                        } catch(err) {
                            this.$emit('error', err);
                        }
                    }
                }
                this.loading = false;
            }
        },
        ...mapActions('bh-toluna-templates', { findItem: 'find' })
    }
}
</script>